import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "pages/components/DataTable";
import MissionWorkflowModal from "../Modal/MissionWorkflowModal";
import PopupForm from "modules/pvs_activities/pages/forms/PopupForm";
import DropdownMenu from "../DropdownMenu";
import { ListItemText, MenuItem, Tooltip } from "@mui/material";
import { USER_ROLES } from "constants";
import { displayNotification, generateOptionsFromData, getAPIURL, getBaseURL, getFormattedDate, getStatus, sendAPIRequest } from "helpers";
import dayjs from "dayjs";
import { Info } from "@material-ui/icons";
import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "components/common/Button";
import { useLazyGetReopenFormQuery, useUpdateMovementStatusMutation } from "modules/pvs_activities/redux/service/movements";
import TaskTabsFilters from "./mission_components/TaskTableFilters";
import { useSubmitDFormMutation } from "modules/pvs_activities/redux/service/dForm";
import { FORM_TYPES, MOVEMENTS_STATUS } from "modules/pvs_activities/constants";
import MissionConfigurationModal from "../Modal/MissionConfigurationModal";
import MissionManagerModal from "../Modal/MissionManagerModal";
import DescriptionIcon from '@mui/icons-material/Description';
const { MissionContext } = require("../contexts/MissionTasksContext");

const TasksTable = ({ children, filtersConfig, movements, cardHeader, showCountry, isCompleted, isMissionManager = false }) => {
    const missionContext = useContext(MissionContext);
    const [movementData, setMovementData] = useState(movements ?? []);
    const authData = useSelector(s => s.auth.data)
    const authToken = useSelector((s) => s.auth.accessToken);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [userData, setUserData] = useState([]);
    const [modalData, setModalData] = useState({
        title: "",
        process_id: null,
        mission_id: null,
        role_id: null,
        user_id: null,
        form_id: null,
        id: null,
        dform_assigned_for: null,
        status: 1,
        mission_region_id: "",
    });
    const [isShow, setIsShow] = useState(false);
    const [showMissionConfiguration, setShowMissionConfiguration] = useState(false);
    const [isShow1, setIsShow1] = useState(false);
    const initModal1 = () => setIsShow1(!isShow1);
    const initModal = () => setIsShow(!isShow);
    const [pvsEvaluationReprot, setPVSEvaluationReprot] = useState(
        movementData.find(movement => parseInt(movement.process_id) === 34 && movement.is_enabled)
    );
    const [reopenTrigger, reopenRes] = useLazyGetReopenFormQuery();
    const [submitDForm, dFormSubmitRes] = useSubmitDFormMutation();
    const [updateMovementStatus, updateMovementStatusRes] = useUpdateMovementStatusMutation();

    useEffect(() => {
        loadUserData();
    }, []);

    const userOptions = useMemo(() => {
        return generateOptionsFromData(userData, {
            value: "id",
            label: "name",
        });
    }, [userData]);


    const loadUserData = async () => {
        try {
            const ret = await sendAPIRequest(`/api/users/?role_id=3`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setUserData(res.data);
            }
        } catch (err) {
            console.log({ err });
        }
    };


    useEffect(() => {
        setMovementData(movements);
        setPVSEvaluationReprot(movementData.find(movement => parseInt(movement.process_id) === 34 && movement.is_enabled));
    }, [movements]);

    const getDateAfterNDays = (days = 3) => {
        const currentDate = dayjs().add(days, 'day')
        return currentDate;
    }

    const openLink = (movementID, dFormID, condition, mission_id) => {
        if (dFormID === null && mission_id) {
            // Ensure the URL starts with a forward slash to avoid appending to the current path
            mission_id && navigate(`/portal/mission-process/${mission_id}/create/?mission_configuration=1`);
        } else {
            const url = `/portal/pvs-activities/${condition === 'view' ? "dform-view" : "dform"}/${dFormID}/${movementID}/`;
            const currentPath = location.pathname;
            localStorage.setItem(`pvsa-process-return-url`, currentPath);
            navigate(url);
        }
    };

    const getLink = (movementID, dFormID, condition, mission_id) => {
        if (dFormID === null && mission_id) {
            // Ensure the URL starts with a forward slash to avoid appending to the current path
            return mission_id ? getBaseURL(`/portal/mission-process/${mission_id}/create/?mission_configuration=1`) : '';
        } else {
            return getBaseURL(`/portal/pvs-activities/${condition === 'view' ? "dform-view" : "dform"}/${dFormID}/${movementID}/`);
        }
    };

    const getClassName = (status, is_enabled, user_id) => {
        if (status === MOVEMENTS_STATUS.skip) {
            return "bg-light-2";
        }
        if (status === MOVEMENTS_STATUS.completed) {
            return "bg-green";
        }
        if (status !== MOVEMENTS_STATUS.completed && is_enabled && user_id === missionContext.missionManager) {
            return "bg-light-orange";
        }
        if (status !== MOVEMENTS_STATUS.completed && is_enabled) {
            return "bg-yellow";
        }
        if (status !== MOVEMENTS_STATUS.completed && !is_enabled) {
            return "bg-light";
        }
        return "bg-secondary"
    }

    const getRowClassName = (status, is_enabled) => {
        if (status !== parseInt(MOVEMENTS_STATUS.completed) && !is_enabled) {
            return "bg-secondary";
        }
    }

    const reopenForm = async (movement_id) => {
        try {
            if (!window.confirm('Are you sure you want to reopen?')) return;
            const response = await reopenTrigger({ movementId: movement_id });
            if (!response.error) {
                displayNotification("success", "Reopened Successfully");
                missionContext.taskTrigger();
            } else {
                displayNotification("error", "Failed to reopen");
            }
        } catch (error) {
            displayNotification("error", "Failed to reopen");
            console.error(error);
        }
    }

    const handleSkip = (templateId, movementId) => {
        if (!window.confirm('Are you sure you want to skip this step?')) return;
        const typ = '';
        const isValidated = '';
        const userId = parseInt(authData.id);
        const skip = true;
        submitDForm({ templateId, movementId, typ, isValidated, userId, skip }).then((response) => {
            if (response.error) {
                displayNotification("error", "An error occured when skipping");
            } else {
                displayNotification("success", response.data.message);
                setMovementData(movements);
            }
        });
    }
    const handleUnskip = (movementId) => {
        if (!window.confirm('Are you sure you want to unskip this step?')) return;
        updateMovementStatus({ movementId, status: MOVEMENTS_STATUS.pending }).then((response) => {
            if (response.error) {
                displayNotification("error", "An error occurred when unskipping");
            } else {
                displayNotification("success", "Successfully Unskipped");

            }
        }).catch((error) => {
            console.error("Error in handleUnskip:", error);
            displayNotification("error", "An unexpected error occurred when unskipping");
        });
    };
    const isValidUser = (assignedUser = null, subMovements = []) => {
        if ((assignedUser && parseInt(assignedUser) === parseInt(authData.id)) || (subMovements.some((m) => (
            m.status !== MOVEMENTS_STATUS.completed && parseInt(m.user_id) === parseInt(authData.id)
        )))) return true;
        return false;
    }
    const canOpenForm = (isEnabled, processStatus, assignedUser, subMovements) => {
        if (isEnabled && processStatus !== MOVEMENTS_STATUS.completed && (isValidUser(assignedUser, subMovements))) {
            return true;
        }
        return false;
    }
    const canReOpenForm = (processStatus) => {
        if (!missionContext.isMissionAborted && parseInt(authData.id) === missionContext.missionManager && processStatus === MOVEMENTS_STATUS.completed) {
            return true;
        }
        return false;
    }
    const canSkipProcess = (isEnabled, processStatus, canAssignProcess) => {
        if (isEnabled && processStatus !== MOVEMENTS_STATUS.completed && canAssignProcess) {
            return true;
        }
        return false;
    }
    const canUnskipProcess = (status, isEnabled, userId) => {
        return status === MOVEMENTS_STATUS.skip && isEnabled && userId === parseInt(authData.id);
    };
    const canAssignProcess = (isEnabled, processStatus, canAssignProcess) => {
        if (isEnabled && processStatus !== MOVEMENTS_STATUS.completed && canAssignProcess) {
            return true;
        }
        return false;
    }
    const canAccessMoreOptions = (isValidated) => {
        if (isValidated && USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) || USER_ROLES.it_admin.includes(parseInt(authData?.role_id))) {
            return true;
        }
        return false;
    }
    const spanInfoIcon = (isManualProcess) => {
        if (isManualProcess && (USER_ROLES.business_admin.includes(parseInt(authData.role_id)) || USER_ROLES.it_admin.includes(parseInt(authData.role_id)) || parseInt(authData.id) === missionContext.missionManager)) {
            return true;
        }
        return false;
    }
    return (
        <>
            <div className="card card-woah border border-secondary shadow-sm rounded-0">
                <div className="card-body p-4">
                    {children}
                    <div className="d-flex mb-2">
                        <div className='d-flex justify-content-between w-100'>
                            <div className="card-title-1 lh-1">{cardHeader}</div>
                            {
                                !showCountry && pvsEvaluationReprot && USER_ROLES.experts.includes(parseInt(authData?.role_id)) &&
                                <Button
                                    onClick={() => openLink(pvsEvaluationReprot.id, pvsEvaluationReprot.d_form_id, 'edit')}
                                    title={getLink(pvsEvaluationReprot.id, pvsEvaluationReprot.d_form_id, 'edit')}
                                >
                                    Open Evalution Report Form
                                </Button>
                            }
                        </div>
                    </div>
                    <TaskTabsFilters
                        config={filtersConfig}
                        movements={movements}
                        movementData={movementData}
                        missionManger={missionContext.missionManager}
                        reloadData={(state => setMovementData(state))}
                        showHeading={true}
                    />
                    <DataTable
                        getRowId={(row) => row.id}
                        isLoading={missionContext.isLoading}
                        className="text-white bg-primary rounded-0"
                        rows={movementData}
                        getRowClassName={(params) => getRowClassName(params.row?.status, params.row?.is_enabled)}
                        columns={[
                            {
                                field: "mission",
                                headerName: t("-1", "Country"),
                                headerClassName: "text-white bg-primary rounded-0",
                                valueGetter: (params) => {
                                    return params.value?.Country?.country_name;
                                },
                                flex: 1,
                            }
                            ,
                            ...[
                                (isCompleted === 0 || isCompleted === 2) && missionContext.processes && missionContext.processes.length > 0 && {
                                    field: "step_no",
                                    headerName: t("-1", "Step No."),
                                    headerClassName: "text-white bg-primary rounded-0",
                                    valueGetter: (params) => {
                                        const step = missionContext.processes.findIndex(process =>
                                            parseInt(params?.row?.relationProcess?.id) === parseInt(process.id)
                                        );
                                        return step !== -1 ? step + 1 : '';
                                    },
                                    flex: 0.5,
                                }
                            ].filter(Boolean),
                            {
                                field: "mission_sector",
                                headerName: t("-1", "Mission Sector"),
                                valueGetter: (params) => {
                                    return params.row?.mission?.mission_sector;
                                },
                                headerClassName: "text-white bg-primary rounded-0",
                                flex: 0,
                            },
                            {
                                field: "missionType",
                                headerName: t("-1", "Mission Type"),
                                valueGetter: (params) => {
                                    return params.row?.mission?.activity_type?.name;
                                },
                                headerClassName: "text-white bg-primary rounded-0",
                                flex: 0,
                            },
                            {
                                field: "relationProcess",
                                headerName: t("-1", "Mission Step"),
                                valueGetter: (params) => {
                                    return params.value ? params.value.name : "Other";
                                },
                                headerClassName: "text-white bg-primary rounded-0",
                                flex: 1,
                            },
                            {
                                field: "status",
                                headerName: t("-1", "Mission Status"),
                                renderCell: (params) => (
                                    <div style={{ maxHeight: "100px", overflowY: "auto" }}>
                                        <div className="col-6 mb-1">
                                            <span
                                                className={`badge rounded-3 p-2 ${getClassName(params.row?.status, params.row?.is_enabled, params.row?.user_id)}`}
                                                style={{ fontSize: "0.875rem" }}
                                            >
                                                <div>
                                                    {
                                                        getStatus(
                                                            params.row?.status,
                                                            params.row?.user_id,
                                                            missionContext.missionManager,
                                                            params.row?.dform_assigned_for,
                                                            params.row?.is_enabled,
                                                            params.row?.relationForm?.relationType?.ref_id,
                                                            params.row?.completed_date,
                                                            params.row?.due_date,
                                                        )
                                                    }
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                ),
                                headerClassName: "text-white bg-primary rounded-0",
                                flex: 2,
                            },
                            {
                                field: "assigned_to",
                                headerName: t("-1", "Assigned To"),
                                headerClassName: "text-white bg-primary rounded-0",
                                flex: 1,
                            },
                            ...[
                                ...(isCompleted == 1 || isCompleted == 2 ? [
                                    {
                                        field: "completed_date_formatted",
                                        valueGetter: (value) => {
                                            return getFormattedDate(value.row?.completed_date_formatted);
                                        },
                                        headerName: t("-1", "Completed Date"),
                                        headerClassName: "text-white bg-primary rounded-0",
                                        flex: 1,
                                    }
                                ] : []),

                                ...(isCompleted == 0 || isCompleted == 2 ? [
                                    {
                                        field: "due_date_formatted",
                                        valueGetter: (params) => {
                                            return getFormattedDate(params.row?.due_date_formatted);
                                        },
                                        headerName: t("-1", "Due Date"),
                                        headerClassName: "text-white bg-primary rounded-0",
                                        flex: 1,
                                    }
                                ] : []),
                            ]
                            ,
                            ...(USER_ROLES.it_admin.includes(parseInt(authData.role_id)) ? [] : [
                                {
                                    field: "actions",
                                    headerClassName: `text-white bg-primary rounded-0`,
                                    headerName: t("-1", "Actions"),
                                    renderCell: (params) => {
                                        let actions = [];
                                        // TODO: check if this is needed for later by Laiba Malik 14-05-2025
                                        // if (canAccessMoreOptions(params.row?.is_validated) && !missionContext.is_archived) {
                                        //     actions.push({
                                        //         text: "Share",
                                        //         onClick: () => { },
                                        //     });
                                        // }
                                        if (canAssignProcess(params.row?.is_enabled, params.row?.status, params.row.can_assign) && !missionContext.is_archived) {
                                            actions.push({
                                                text: `Assign`,
                                                onClick: () => {
                                                    setModalData({
                                                        ...modalData,
                                                        assigned_by: authData.id,
                                                        title: params.row.relationProcess ? params.row.relationProcess?.name : "Other",
                                                        process_id: params.row.process_id,
                                                        mission_id: params.row.mission_id,
                                                        role_id: params.row.relationUser?.role_id,
                                                        user_id: params.row.relationUser?.id,
                                                        form_id: params.row.d_form_id,
                                                        process_role_id: params.row?.relationProcess?.role_id,
                                                        status: params.row?.status,
                                                        id: params.row.id,
                                                        dform_assigned_for: params.row?.dform_assigned_for,
                                                        country_region_id: params.row.mission?.Country?.region_id,
                                                        due_date: getDateAfterNDays(3),
                                                    });
                                                    initModal();
                                                },
                                            });
                                        }
                                        if (
                                            params?.row?.status === MOVEMENTS_STATUS.completed &&
                                            params?.row?.is_pdf_generated &&
                                            params?.row?.document_id &&
                                            !missionContext.is_archived
                                        ) {
                                            actions.push({
                                                text: "View Pdf",
                                                onClick: () => {
                                                    const pdfUrl = getAPIURL(
                                                        `/api/pvsa/mission-documents/download/${params.row?.document_id}?_token=${authToken}&view=true`
                                                    );
                                                    window.open(pdfUrl, "_blank");
                                                }
                                            });
                                        }
                                        if (params.row?.relationForm?.is_popup_form && !missionContext.is_archived) {
                                            if (canOpenForm(params.row?.is_enabled, params.row?.status, params.row?.user_id, params.row?.relationSubMovement)) {
                                                actions.push({
                                                    el: (k, handleClose) => (
                                                        <PopupForm
                                                            mode={"data_entry"}
                                                            id={params.row.d_form_id}
                                                            movementId={params.row.id}
                                                            onClose={() => {
                                                                handleClose();
                                                                missionContext.taskTrigger();
                                                            }}
                                                        >
                                                            {(openModal) => (
                                                                <MenuItem key={k} onClick={() => openModal()}>
                                                                    <ListItemText>Open Form</ListItemText>
                                                                </MenuItem>
                                                            )}
                                                        </PopupForm>
                                                    ),
                                                });
                                            } else {
                                                actions.push({
                                                    el: (k, handleClose) => (
                                                        <PopupForm
                                                            mode={"data_entry"}
                                                            id={params.row.d_form_id}
                                                            movementId={params.row.id}
                                                            onClose={() => {
                                                                handleClose();
                                                                missionContext.taskTrigger();
                                                            }}
                                                        >
                                                            {(openModal) => (
                                                                <MenuItem key={k} onClick={() => openModal()}>
                                                                    <ListItemText>View Form</ListItemText>
                                                                </MenuItem>
                                                            )}
                                                        </PopupForm>
                                                    ),
                                                });
                                                if (canReOpenForm(params.row?.status)) {
                                                    actions.push({
                                                        text: "Reopen Form",
                                                        onClick: () => reopenForm(params.row.id),
                                                    });
                                                }

                                            }
                                        } else {
                                            if (canOpenForm(params.row?.is_enabled, params.row?.status, params.row?.user_id, params.row?.relationSubMovement) && !missionContext.is_archived) {
                                                actions.push({
                                                    text: "Open Form",
                                                    title: getLink(params.row.id, params.row.d_form_id, 'edit', params.row.mission_id),
                                                    onClick: () => openLink(params.row.id, params.row.d_form_id, 'edit', params.row.mission_id),
                                                });
                                            } else {
                                                actions.push({
                                                    text: "View Form",
                                                    title: getLink(params.row.id, params.row.d_form_id, 'view'),
                                                    onClick: () => openLink(params.row.id, params.row.d_form_id, 'view'),
                                                });
                                                if (canReOpenForm(params.row?.status) && !missionContext.is_archived) {
                                                    actions.push({
                                                        text: "Reopen Form",
                                                        onClick: () => reopenForm(params.row.id),
                                                    });
                                                }
                                            }
                                        }
                                        if (isMissionManager && !missionContext.is_archived) {
                                            if (
                                                canSkipProcess(params.row?.is_enabled, params.row?.status, params.row.can_assign) &&
                                                params.row?.status !== MOVEMENTS_STATUS.skip
                                            ) {
                                                actions.push({
                                                    text: 'Skip',
                                                    onClick: () => handleSkip(params.row.d_form_id, params.row.id),
                                                });
                                            } else if (
                                                canUnskipProcess(params.row?.status, params.row?.is_enabled, parseInt(authData.id))
                                            ) {
                                                actions.push({
                                                    text: 'Unskip',
                                                    onClick: () => handleUnskip(params.row.id),
                                                });
                                            }
                                        }
                                        return <span>
                                            <DropdownMenu items={actions} color={(params.row?.is_enabled && params.row?.status !== parseInt(MOVEMENTS_STATUS.completed)) ? "primary" : "black"} />
                                            {
                                                spanInfoIcon(params.row?.relationProcess?.is_manual_process) &&
                                                <Tooltip
                                                    title={t("-1", "This Form is automatically coming from rule engine.")}
                                                    placement="top"
                                                    arrow
                                                >
                                                    <Info color={(params.row?.is_enabled && params.row?.status !== parseInt(MOVEMENTS_STATUS.completed)) ? "primary" : "black"}></Info>
                                                </Tooltip>
                                            }
                                            {
                                                params.row?.relationForm?.type_ref === FORM_TYPES.letter &&
                                                <Tooltip
                                                    title={t("-1", "This process is for letters and follows the letter workflow.")}
                                                    placement="top"
                                                    arrow
                                                >
                                                    <DescriptionIcon
                                                        sx={{ color: '#868686' }}
                                                    ></DescriptionIcon>
                                                </Tooltip>
                                            }
                                        </span>;
                                    },
                                },
                            ])
                        ]}
                        sortModel={
                            isCompleted == 1
                                ? {
                                    fields: ["completed_date"],
                                    sort: "asc",
                                }
                                : isCompleted == 0
                                    ? {
                                        fields: ["due_date"],
                                        sort: "asc",
                                    }
                                    : {
                                        fields: ["completed_date", "due_date"],
                                        sort: "asc",
                                    }
                        }
                    />
                </div>
            </div>
            <MissionWorkflowModal
                isShow={isShow}
                initModal={initModal}
                modalData={modalData}
                setModalData={setModalData}
            />
            <MissionManagerModal
                isShow={isShow1}
                initModal={initModal1}
                data={userOptions}
            />
            {
                showMissionConfiguration &&
                <MissionConfigurationModal
                    isShow={showMissionConfiguration}
                    initModal={() => setShowMissionConfiguration(prev => !prev)}
                    isShow1={isShow1}
                    initModal1={initModal1}
                    userOptions={userOptions}
                />
            }

        </>
    );
}

export default TasksTable;